export default "__VITE_ASSET__BTG2Ud9y__"